import { fetchLatestPrescan } from "../../redux/modules/prescan/asyncActions";
import { IGcpAppDispatch } from "../../redux/store";
import { loadFlightMarkers } from "../../redux/modules/flightMarkers/flightMarkersAsyncActions";
import { fetchSite } from "../../redux/modules/site/asyncActions";
import {
  enableAllVisibility,
  enableExistingVisibility,
  enableProblemVisibility,
} from "../../redux/modules/ui/reducer";
import { fetchCurrentGcpRequest } from "../../redux/modules/gcpRequest/asyncActions";
import {
  fetchMaidenScan,
  isSatelliteMaiden,
} from "../../apiFacades/bapi/maidenScan";
import { persistAnyScan } from "../../redux/modules/anyScan/reducer";
import currentGcpRequestStore from "./currentGCPRequestStore";

export const userOpensCurrentGCPRequestPage =
  (customerId: string, siteId: string) => async (dispatch: IGcpAppDispatch) => {
    const currentGcpRequestStoreState = currentGcpRequestStore.getState();

    /**
     * Fetch latest GCP request
     */
    let hasCurrentGCPRequest = true;

    dispatch(fetchCurrentGcpRequest(customerId, siteId)).catch((e) => {
      hasCurrentGCPRequest = false;
      // ok if no request — will just show flight markers map
    });

    /**
     * Fetch flight markers
     */
    let hasFlightMarkers = true;

    dispatch(loadFlightMarkers(customerId, siteId)).catch(() => {
      hasFlightMarkers = false;
      // It is ok to have no flight markers.
      // Customer can ask for an advanced scan after having requested only basic scans before
    });

    /**
     * Fetch site
     */
    const site = await dispatch(fetchSite(customerId, siteId)).catch(
      (error) => {
        if (error.response.statusText === "Unauthorized") {
          throw new Error(
            "Oops! This project isn’t available anymore. It might be expired or you might not have access. Let your team know if you think this is a mistake.",
          );
        }
        if (error.response?.data?.error?.code === "SITE_NOT_FOUND") {
          throw new Error(
            "Oops! An error occurred: The project you're looking for doesn't exist.",
          );
        }

        throw new Error("Oops! An error occurred: Could not fetch site.");
      },
    );

    currentGcpRequestStoreState.setSite(site);

    /**
     * Fetch latest prescan
     */
    let isInitial = true;
    try {
      // If there is a scan with a date, then this request isn't initial anymore
      await dispatch(fetchLatestPrescan(customerId, siteId));
      isInitial = false;
    } catch {
      // If no scan with a date, we treat this request as initial
    }

    if (isInitial) {
      try {
        // If it is initial - try to fetch Maiden
        const maidenScan = await dispatch(fetchMaidenScan(customerId, siteId));

        dispatch(
          persistAnyScan({
            orthophotoTilesPath: maidenScan.orthophotoTilesPath,
            elevationMapTilesPath: maidenScan.elevationMapTilesPath,
            isSatellite: isSatelliteMaiden(maidenScan),
          }),
        );
      } catch {
        // It is ok if there is no Maiden - users can use the satellite overlay
      }
    }

    if (hasFlightMarkers && !site.srs) {
      throw new Error("No SRS but has flight markers — can't show them");
    }

    if (hasCurrentGCPRequest) {
      dispatch(enableExistingVisibility());
      dispatch(enableProblemVisibility());
    } else {
      dispatch(enableAllVisibility());
    }

    return MODE_CURRENT_GCP_REQUEST_VIEW;
  };

export const MODE_CURRENT_GCP_REQUEST_VIEW = "MODE_CURRENT_GCP_REQUEST_VIEW";
